import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Modal, Button, Spinner, Form, Tab, Nav } from "react-bootstrap";
import { useParams, useNavigate } from 'react-router-dom';
import MyApiClient from "../../../../../api-client/MyApiClient";
import Select from "react-select";
import { italianProvinces } from "../../../../components/Util/enum";

import { conMotivo } from "../../../../components/Util/erroreServer";
import { usePageTitle, useStatoInSolaLettura } from "../../../../layouts/PageHeaderExtra";
import { apriFile } from '../../../../components/Util/anteprimaFile';
import segnalaMancanti from '../../../../components/Util/campiMancanti';
export const AdminUserTransactionsEdit = () => {
    const navigate = useNavigate();

    const { id } = useParams();
    const formRefs = useRef({});

    const [loadingShowed, setLoadingShowed] = useState(false);
    const [confirmShowed, setConfirmShowed] = useState(false);
    const [confirmText, setConfirmText] = useState('');

    const optionsFatturazione = [
        { value: "privato", label: "Privato" },
        { value: "azienda", label: "Azienda" }
    ]

    const [tabIndex, setTabIndex] = useState(0);

    const [modalShowed, setModalShowed] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const [userBookingTransactions] = await Promise.all([
                        apiClient.getUserBookingTransactionById(token, id)
                    ]);
                    setLoadingShowed(false);
                    
                    if(userBookingTransactions) {

                        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
                        const invoiceDateEl = userBookingTransactions.invoice_date;
                        const invoiceDate = new Date(invoiceDateEl);
                        const formattedInvoiceDate = invoiceDate.toLocaleDateString('it-IT', options);

                        const createdAt = userBookingTransactions.createdAt;
                        const dateCreated = new Date(createdAt);
                        const options2 = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
                        const formattedDate = dateCreated.toLocaleDateString('it-IT', options2);

                        let type_document = null;
                        if(userBookingTransactions.type === 'INVOICE') {
                            type_document = 'Fattura';
                        } else if(userBookingTransactions.type === 'RECEIPT') {
                            type_document = 'Ricevuta';
                        }

                        let status = null;
                        if(userBookingTransactions.invoice_status === 'SENT') {
                            status = {
                                "label": "Inviato",
                                "class": "text-primary"
                            };
                        } else if(userBookingTransactions.invoice_status === 'ACCEPTED') {
                            status = {
                                "label": "Accettato",
                                "class": "text-success"
                            };
                        } else if(userBookingTransactions.invoice_status === 'REJECTED') {
                            status = {
                                "label": "Rifiutato",
                                "class": "text-danger"
                            };
                        } else if(userBookingTransactions.invoice_status === 'NOT_SENT') {
                            status = {
                                "label": "Non inviato",
                                "class": "text-warning"
                            };
                        } else if(userBookingTransactions.invoice_status === 'NOT_GENERATED') {
                            status = {
                                "label": "Non generato",
                                "class": "text-error"
                            };
                        }

                        const elementFormData = {
                            id: userBookingTransactions.id,
                            clubId: userBookingTransactions.clubId,
                            playerId: userBookingTransactions.playerId,
                            playerName: userBookingTransactions.playerName,
                            juniorId: userBookingTransactions.juniorId,
                            subscriptionId: userBookingTransactions.subscription_id,
                            userSubscriptionId: userBookingTransactions.user_subscription_id,
                            type: userBookingTransactions.type,
                            createdAt: formattedDate,
                            invoice_date: formattedInvoiceDate,
                            price: "€ "+(userBookingTransactions.amount).toFixed(2),
                            type_document: type_document,
                            invoice_number: userBookingTransactions.invoice_number_str,
                            status: status,
                            pdf_document: userBookingTransactions.pdf_document,
                            xml_document: userBookingTransactions.xml_document,
                            status_label: userBookingTransactions.invoice_status,
                            sdi_notification: userBookingTransactions.sdi_notification,
                            sdi_rejection_errors: userBookingTransactions.sdi_rejection_errors
                        };

                        if(userBookingTransactions.receiver) {
                            elementFormData.codice_fiscale = userBookingTransactions.receiver.tax_code;
                            elementFormData.email = userBookingTransactions.receiver.pec;
                            elementFormData.indirizzo = userBookingTransactions.receiver.address;
                            elementFormData.cap = userBookingTransactions.receiver.zip_code;
                            elementFormData.citta = userBookingTransactions.receiver.city;
                            elementFormData.provincia = userBookingTransactions.receiver.province;
                            if(userBookingTransactions.receiver.type === 'consumer') {
                                elementFormData.tipo_cliente = 'privato';
                                elementFormData.nome = userBookingTransactions.receiver.first_name;
                                elementFormData.cognome = userBookingTransactions.receiver.last_name;
                            } else if(userBookingTransactions.receiver.type === 'business') {
                                elementFormData.tipo_cliente = 'azienda';
                                elementFormData.ragione_sociale = userBookingTransactions.receiver.denomination;
                                elementFormData.partita_iva = userBookingTransactions.receiver.vat_number;
                                elementFormData.codice_destinatario = userBookingTransactions.receiver.sdi_code;
                            }
                        }

                        setFormData(elementFormData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [id]);

    const [formData, setFormData] = useState({
        id: '',
        clubId: '',
        playerId: '',
        playerName: '',
        juniorId: '',
        subscriptionId: '',
        userSubscriptionId: '',
        type: '',
        createdAt: '',
        invoice_date: '',
        price: '',
        type_document: '',
        invoice_number: '',
        status: {},
        status_label: '',
        pdf_document: '',
        xml_document: '',
        sdi_rejection_errors: [],
        // receiver
        tipo_cliente: '',
        // business
        ragione_sociale: '',
        partita_iva: '',
        codice_destinatario: '',
        // privato
        nome: '',
        cognome: '',
        codice_fiscale: '',
        email: '',
        indirizzo: '',
        cap: '',
        citta: '',
        provincia: '',
        nazione: '',
    });

    const handleSelectChange = (selectedOption, name) => {
        const selectedValue = Array.isArray(selectedOption)
            ? selectedOption.map(option => option.value)
            : selectedOption?.value || '';
    
        setFormData(prev => ({
            ...prev,
            [name]: selectedValue,
        }));
    };

    // Titolo della pagina = il documento («Fattura 12/2026»), appena caricato.
    usePageTitle(formData?.type_document && formData?.invoice_number ? `${formData.type_document} ${formData.invoice_number}` : '');

    // Stato del documento in sola lettura accanto al titolo
    useStatoInSolaLettura(formData?.status?.label, formData?.status_label === 'ACCEPTED' ? 'attivo' : ['REJECTED', 'NOT_SENT'].includes(formData?.status_label) ? 'non-attivo' : 'bozza');

    // «Download XML»: era nel menu a fine riga della lista, ora sta nella tab Documento XML (03/10/2026).
    const downloadXml = (row) => {
	
		const downloadXmlData = async () => {
			try {
				const tokenDetailsString = sessionStorage.getItem('userDetails');
				if (tokenDetailsString) {
					const tokenDetails = JSON.parse(tokenDetailsString);
					const token = tokenDetails.idToken;
					const apiClient = new MyApiClient();

					setLoadingShowed(true);
					const response = await apiClient.downloadTransactionXml(token, row.id);
					setLoadingShowed(false);

					if(!response) {
						setModalTitle("Errore durante l'operazione");
						setModalText(conMotivo("Si è verificato un errore durante il download"));
						setModalShowed(true);
					} else {
						const blob = new Blob([response.data], { type: 'application/xml' });
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `fattura_${row.id}.xml`);
						document.body.appendChild(link);
						link.click();
						link.parentNode.removeChild(link);
						window.URL.revokeObjectURL(url);
					}
				}
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		};

		downloadXmlData();
	};

    // Dati del destinatario mancanti o scritti male: si evidenziano i campi, senza bolle del browser (set-ui «Dati mancanti»)
    const saveReceiver = () => {
        const vuoto = (v) => !String(v ?? '').trim();
        const mancanti = [];
        if (vuoto(formData.tipo_cliente)) mancanti.push({ campo: 'ut-tipo_cliente', messaggio: 'Manca il tipo di cliente' });
        if (formData.tipo_cliente === 'azienda') {
            if (vuoto(formData.ragione_sociale)) mancanti.push({ campo: 'ut-ragione_sociale', messaggio: 'Manca la ragione sociale' });
            if (vuoto(formData.partita_iva)) mancanti.push({ campo: 'ut-partita_iva', messaggio: 'Manca la partita IVA' });
            else if (formData.partita_iva.length !== 11 || isNaN(formData.partita_iva)) mancanti.push({ campo: 'ut-partita_iva', messaggio: `La partita IVA deve avere 11 cifre numeriche: ne hai scritte ${formData.partita_iva.length}` });
            if (vuoto(formData.codice_destinatario)) mancanti.push({ campo: 'ut-codice_destinatario', messaggio: 'Manca il codice destinatario (SDI)' });
        } else if (formData.tipo_cliente === 'privato') {
            if (vuoto(formData.nome)) mancanti.push({ campo: 'ut-nome', messaggio: 'Manca il nome' });
            if (vuoto(formData.cognome)) mancanti.push({ campo: 'ut-cognome', messaggio: 'Manca il cognome' });
        }
        if (vuoto(formData.codice_fiscale)) mancanti.push({ campo: 'ut-codice_fiscale', messaggio: 'Manca il codice fiscale' });
        else {
            const cf = formData.codice_fiscale;
            const cfValido = (cf.length === 16 && /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i.test(cf)) || (cf.length === 11 && !isNaN(cf));
            if (!cfValido) mancanti.push({ campo: 'ut-codice_fiscale', messaggio: 'Controlla il codice fiscale (16 caratteri) o la partita IVA (11 cifre)' });
        }
        if (vuoto(formData.email)) mancanti.push({ campo: 'ut-email', messaggio: 'Manca l\'email o la PEC' });
        if (vuoto(formData.indirizzo)) mancanti.push({ campo: 'ut-indirizzo', messaggio: 'Manca l\'indirizzo' });
        if (vuoto(formData.cap)) mancanti.push({ campo: 'ut-cap', messaggio: 'Manca il CAP' });
        if (vuoto(formData.citta)) mancanti.push({ campo: 'ut-citta', messaggio: 'Manca la città' });
        if (vuoto(formData.provincia)) mancanti.push({ campo: 'ut-provincia', messaggio: 'Manca la provincia' });
        if (segnalaMancanti(mancanti) > 0) return;

        setConfirmShowed(true);
        setConfirmText("I dati del destinatario saranno aggiornati e i documenti rigenerati.");
    };

    const continueUpdate = () => {
        
        setConfirmShowed(false);

        const updateData = async () => {
            try {
                const dati_fatturazione = {
                    tax_code: formData.codice_fiscale,
                    pec: formData.email,
                    address: formData.indirizzo,
                    zip_code: formData.cap,
                    city: formData.citta,
                    province: formData.provincia,
                    nation: 'IT',
                    country_code: 'IT',
                }
                if(formData.tipo_cliente === 'privato') {
                    dati_fatturazione.type = 'consumer';
                    dati_fatturazione.first_name = formData.nome;
                    dati_fatturazione.last_name = formData.cognome;
                } else if(formData.tipo_cliente === 'azienda') {
                    dati_fatturazione.type = 'business';
                    dati_fatturazione.denomination = formData.ragione_sociale;
                    dati_fatturazione.vat_number = formData.partita_iva;
                    dati_fatturazione.sdi_code = formData.codice_destinatario;
                }

                const dataCreate = {
                    id: formData.id,
                    receiver: dati_fatturazione
                }

                const tokenDetailsString = sessionStorage.getItem('userDetails');
                if (tokenDetailsString) {
                    const tokenDetails = JSON.parse(tokenDetailsString);
                    const token = tokenDetails.idToken;
                    const apiClient = new MyApiClient();

                    setLoadingShowed(true);
                    const deleteResult = await apiClient.updateBookingTransaction(token, dataCreate);
                    setLoadingShowed(false);

                    if(!deleteResult) {
                        setModalTitle("Errore durante l'operazione");
                        setModalText(conMotivo("Si è verificato un errore durante l'aggiornamento"));
                        setModalShowed(true);
                    } else {
                        navigate('/superadmin/booking/userTransactions');
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        updateData();
    };

    const isDisabled = true;

    const tabData = [
        {
            id: 'informazioni_generali',
            name: "Informazioni generali",
            visible: true,
            content: (
                <>
                    <div className="col-xl-12">
                        <Card>
                            <Card.Header><h4 className="card-title">Dettagli del documento</h4></Card.Header>
                            <Card.Body>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Label>Creazione</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="createdAt"
                                            value={formData.createdAt}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Nome e cognome</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="playerName"
                                            value={formData.playerName}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Data</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="invoice_date"
                                            value={formData.invoice_date}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Importo</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="price"
                                            value={formData.price}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        <Form.Label>Tipo documento</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="type_document"
                                            value={formData.type_document}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Label>Numero documento</Form.Label>
                                        <Form.Control
                                            disabled
                                            style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                            className="mt-2"
                                            type="text"
                                            name="invoice_number"
                                            value={formData.invoice_number}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-4">
                                    <Col lg={6}>
                                        {(formData.sdi_notification === 'MC' || formData.sdi_notification === 'AT') && (
                                            <small className="text-muted d-block mt-1">
                                                <i className="fa fa-info-circle me-1"></i>
                                                Fattura messa a disposizione del destinatario sul cassetto fiscale dell'Agenzia delle Entrate.
                                            </small>
                                        )}
                                    </Col>
                                </Row>
                                {formData.sdi_rejection_errors && formData.sdi_rejection_errors.length > 0 && (
                                    <Row className="mt-4">
                                        <Col lg={12}>
                                            <div className="alert alert-danger mb-0">
                                                <h5 className="alert-heading mb-2"><i className="fa fa-exclamation-triangle me-2"></i>Errori di scarto SDI</h5>
                                                <ul className="mb-0 ps-3">
                                                    {formData.sdi_rejection_errors.map((err, index) => (
                                                        <li key={index}>
                                                            <strong>{err.Codice}:</strong> {err.Descrizione}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </Col>
                                    </Row>
                                )}
                            </Card.Body>
                        </Card>
                        <Card>
                            <Card.Header><h4 className="card-title">Destinatario</h4></Card.Header>
                            <Card.Body>
                                <Form ref={el => formRefs.current[0] = el} noValidate>
                                    <Row>
                                        {/* Selezione Tipo Cliente */}
                                        <Col md={12}>
                                            <Form.Label htmlFor="ut-tipo_cliente">Tipo Cliente{!isDisabled && ' *'}</Form.Label>
                                            <Select
                                                inputId="ut-tipo_cliente"
                                                isDisabled={isDisabled}
                                                className="mt-2"
                                                name="tipo_cliente"
                                                value={optionsFatturazione.find(option => option.value === formData.tipo_cliente)}
                                                onChange={(selectedOption) => handleSelectChange(selectedOption, "tipo_cliente")} 
                                                options={optionsFatturazione}
                                            />
                                        </Col>
                                    </Row>
                                    {/* Azienda */}
                                    {formData.tipo_cliente === 'azienda' && (
                                        <Row className="mt-4">
                                            <Col lg={4}>
                                                <Form.Label htmlFor="ut-ragione_sociale">Ragione sociale{!isDisabled && ' *'}</Form.Label>
                                                <Form.Control
                                                    id="ut-ragione_sociale"
                                                    disabled={isDisabled}
                                                    style={isDisabled
                                                        ? {
                                                            color: 'rgba(108,117,125,0.6)',
                                                            backgroundColor: '#f2f2f2',
                                                            paddingLeft: '15px',
                                                            fontWeight: 'normal',
                                                        }
                                                        : {}
                                                    }
                                                    className="mt-2"
                                                    type="text"
                                                    name="ragione_sociale"
                                                    value={formData.ragione_sociale}
                                                    onChange={e => setFormData(prev => ({ ...prev, ragione_sociale: e.target.value }))}
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Form.Label htmlFor="ut-partita_iva">Partita IVA{!isDisabled && ' *'}</Form.Label>
                                                <Form.Control
                                                    id="ut-partita_iva"
                                                    disabled={isDisabled}
                                                    style={isDisabled
                                                        ? {
                                                            color: 'rgba(108,117,125,0.6)',
                                                            backgroundColor: '#f2f2f2',
                                                            paddingLeft: '15px',
                                                            fontWeight: 'normal',
                                                        }
                                                        : {}
                                                    }
                                                    className="mt-2"
                                                    type="text"
                                                    name="partita_iva"
                                                    value={formData.partita_iva}
                                                    onChange={e => setFormData(prev => ({ ...prev, partita_iva: e.target.value }))}
                                                />
                                            </Col>
                                            <Col lg={4}>
                                                <Form.Label htmlFor="ut-codice_destinatario">Codice Destinatario (SDI){!isDisabled && ' *'}</Form.Label>
                                                <Form.Control
                                                    id="ut-codice_destinatario"
                                                    disabled={isDisabled}
                                                    style={isDisabled
                                                        ? {
                                                            color: 'rgba(108,117,125,0.6)',
                                                            backgroundColor: '#f2f2f2',
                                                            paddingLeft: '15px',
                                                            fontWeight: 'normal',
                                                        }
                                                        : {}
                                                    }
                                                    className="mt-2"
                                                    type="text"
                                                    name="codice_destinatario"
                                                    value={formData.codice_destinatario}
                                                    onChange={e => setFormData(prev => ({ ...prev, codice_destinatario: e.target.value }))}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                                    {/* Privato */}
                                    {formData.tipo_cliente === 'privato' && (
                                        <Row className="mt-4">
                                            <Col lg={6}>
                                                <Form.Label htmlFor="ut-nome">Nome{!isDisabled && ' *'}</Form.Label>
                                                <Form.Control
                                                    id="ut-nome"
                                                    disabled={isDisabled}
                                                    style={isDisabled
                                                        ? {
                                                            color: 'rgba(108,117,125,0.6)',
                                                            backgroundColor: '#f2f2f2',
                                                            paddingLeft: '15px',
                                                            fontWeight: 'normal',
                                                        }
                                                        : {}
                                                    }
                                                    className="mt-2"
                                                    type="text"
                                                    name="nome"
                                                    value={formData.nome}
                                                    onChange={e => setFormData(prev => ({ ...prev, nome: e.target.value }))}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <Form.Label htmlFor="ut-cognome">Cognome{!isDisabled && ' *'}</Form.Label>
                                                <Form.Control
                                                    id="ut-cognome"
                                                    disabled={isDisabled}
                                                    style={isDisabled
                                                        ? {
                                                            color: 'rgba(108,117,125,0.6)',
                                                            backgroundColor: '#f2f2f2',
                                                            paddingLeft: '15px',
                                                            fontWeight: 'normal',
                                                        }
                                                        : {}
                                                    }
                                                    className="mt-2"
                                                    type="text"
                                                    name="cognome"
                                                    value={formData.cognome}
                                                    onChange={e => setFormData(prev => ({ ...prev, cognome: e.target.value }))}
                                                />
                                            </Col>
                                        </Row>
                                    )}

                                    {/* Campi comuni */}
                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label htmlFor="ut-codice_fiscale">Codice Fiscale{!isDisabled && ' *'}</Form.Label>
                                            <Form.Control
                                                id="ut-codice_fiscale"
                                                disabled={isDisabled}
                                                style={isDisabled
                                                    ? {
                                                        color: 'rgba(108,117,125,0.6)',
                                                        backgroundColor: '#f2f2f2',
                                                        paddingLeft: '15px',
                                                        fontWeight: 'normal',
                                                    }
                                                    : {}
                                                }
                                                className="mt-2"
                                                type="text"
                                                name="codice_fiscale"
                                                value={formData.codice_fiscale}
                                                onChange={e => setFormData(prev => ({ ...prev, codice_fiscale: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Label htmlFor="ut-email">Email PEC / Email{!isDisabled && ' *'}</Form.Label>
                                            <Form.Control
                                                id="ut-email"
                                                disabled={isDisabled}
                                                style={isDisabled
                                                    ? {
                                                        color: 'rgba(108,117,125,0.6)',
                                                        backgroundColor: '#f2f2f2',
                                                        paddingLeft: '15px',
                                                        fontWeight: 'normal',
                                                    }
                                                    : {}
                                                }
                                                className="mt-2"
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label htmlFor="ut-indirizzo">Indirizzo{!isDisabled && ' *'}</Form.Label>
                                            <Form.Control
                                                id="ut-indirizzo"
                                                disabled={isDisabled}
                                                style={isDisabled
                                                    ? {
                                                        color: 'rgba(108,117,125,0.6)',
                                                        backgroundColor: '#f2f2f2',
                                                        paddingLeft: '15px',
                                                        fontWeight: 'normal',
                                                    }
                                                    : {}
                                                }
                                                className="mt-2"
                                                type="text"
                                                name="indirizzo"
                                                value={formData.indirizzo}
                                                onChange={e => setFormData(prev => ({ ...prev, indirizzo: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Label htmlFor="ut-cap">CAP{!isDisabled && ' *'}</Form.Label>
                                            <Form.Control
                                                id="ut-cap"
                                                disabled={isDisabled}
                                                style={isDisabled
                                                    ? {
                                                        color: 'rgba(108,117,125,0.6)',
                                                        backgroundColor: '#f2f2f2',
                                                        paddingLeft: '15px',
                                                        fontWeight: 'normal',
                                                    }
                                                    : {}
                                                }
                                                className="mt-2"
                                                type="text"
                                                name="cap"
                                                value={formData.cap}
                                                onChange={e => setFormData(prev => ({ ...prev, cap: e.target.value }))}
                                            />
                                        </Col>
                                        <Col lg={3}>
                                            <Form.Label htmlFor="ut-citta">Città{!isDisabled && ' *'}</Form.Label>
                                            <Form.Control
                                                id="ut-citta"
                                                disabled={isDisabled}
                                                style={isDisabled
                                                    ? {
                                                        color: 'rgba(108,117,125,0.6)',
                                                        backgroundColor: '#f2f2f2',
                                                        paddingLeft: '15px',
                                                        fontWeight: 'normal',
                                                    }
                                                    : {}
                                                }
                                                className="mt-2"
                                                type="text"
                                                name="citta"
                                                value={formData.citta}
                                                onChange={e => setFormData(prev => ({ ...prev, citta: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-4">
                                        <Col lg={6}>
                                            <Form.Label htmlFor="ut-provincia">Provincia{!isDisabled && ' *'}</Form.Label>
                                            <Select
                                                inputId="ut-provincia"
                                                isDisabled={isDisabled}
                                                className="mt-2"
                                                name="provincia"
                                                value={italianProvinces.find(option => option.value === formData.provincia)}
                                                onChange={(selectedOption) => handleSelectChange(selectedOption, "provincia")} 
                                                options={italianProvinces}
                                            />
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Label>Nazione</Form.Label>
                                            <Form.Control
                                                disabled={true}
                                                style={{color: 'rgba(108,117,125,0.6)', backgroundColor: '#f2f2f2', paddingLeft: "15px", fontWeight: "normal" }}
                                                className="mt-2"
                                                type="text"
                                                name="nazione"
                                                value="Italia"
                                                onChange={e => setFormData(prev => ({ ...prev, nazione: e.target.value }))}
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        {!isDisabled && (
                            <div className="d-flex justify-content-end mt-4">
                                <button type="button" className="btn btn-primary" onClick={() => saveReceiver()}>Salva dati destinatario</button>
                            </div>
                        )}
                    </div>
                </>
            ),
        },
        {
            id: 'documento_pdf',
            name: "Documento PDF",
            visible: true,
            content: (
                <>
                    {/* Il PDF si vede nella finestra di anteprima (set-ui anteprima-file) */}
                    <div className="text-center py-5">
                        <Button className="btn btn-primary" onClick={() => apriFile({ uri: formData.pdf_document, nome: 'Documento.pdf', tipo: 'application/pdf' })}>Visualizza PDF</Button>
                    </div>
                </>
            ),
        },
        {
            id: 'documento_xml',
            name: "Documento XML",
            visible: formData.type === 'INVOICE',
            content: (
                <>
                    <textarea
                        value={formData.xml_document || ''}
                        readOnly
                        style={{
                        width: '100%',
                        height: '500px',
                        fontFamily: 'monospace',
                        fontSize: '14px',
                        padding: '1rem',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        backgroundColor: '#f9f9f9',
                        whiteSpace: 'pre-wrap',
                        }}
                    />
                    {formData.status_label !== 'NOT_GENERATED' && (
                        <div className="d-flex justify-content-end mt-4">
                            <button type="button" className="btn btn-primary" onClick={() => downloadXml(formData)}>Download XML</button>
                        </div>
                    )}
                </>
            ),
        },
    ];

    return (
        <>
            <Modal className="fade" show={confirmShowed} centered>
                <Modal.Header>
                    <Modal.Title>Aggiornare i dati del destinatario?</Modal.Title>
                    <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{confirmText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                        Annulla
                    </Button>
                    <Button className="btn btn-primary btn-add" onClick={() => continueUpdate()}>
                        Aggiorna
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={modalShowed} centered>
                <Modal.Header>
                    <Modal.Title>{modalTitle}</Modal.Title>
                    <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <Row><Col className="col-xl-64">{modalText}</Col></Row>
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button className="btn btn-primary btn-add" onClick={() => setModalShowed(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal className="fade" show={loadingShowed} centered>
                <Modal.Body className="text-center">
                <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                </Spinner>
                <div>Caricamento in corso...</div>
                </Modal.Body>
            </Modal>

            <div className="custom-tab-1">
                <Tab.Container activeKey={tabData[tabIndex]?.id.toLowerCase()}>
                    <Nav as="ul" className="nav-tabs" style={{ border: 'none' }}>
                        {tabData.map((data, i) => (
                            <Nav.Item as="li" key={i} className="tabMenu">
                                {data.visible && <Nav.Link onClick={() => setTabIndex(i)} eventKey={data.id.toLowerCase()}>
                                    {data.name}
                                </Nav.Link>}
                            </Nav.Item>
                        ))}
                    </Nav>
                    <Row className="align-items-start mt-4">
                        <div className="col-xl-9">
                            <Tab.Content>
                                {tabData.map((data, i) => (
                                    <Tab.Pane eventKey={data.id.toLowerCase()} key={i}>
                                        {data.content}
                                    </Tab.Pane>
                                ))}
                            </Tab.Content>
                        </div>
                        <div className="col-xl-3">
                            <Card>
                                <Card.Body className="text-left">
                                    {formData.type==='INVOICE' && <div>
                                    Stai visualizzando un documento <b>Fattura</b>.
                                    <br></br><br></br>
                                    Puoi visualizzare i dettagli della ricevuta per questo acquisto, visualizzare il PDF e l'XML generati e modificare i dati del destinatario se la fattura non è ancora stata inviata allo SDI.
                                    </div>}
                                    {formData.type==='RECEIPT' && <div>
                                    Stai visualizzando un documento <b>Ricevuta</b>.
                                    <br></br><br></br>
                                    Puoi visualizzare i dettagli della ricevuta per questo acquisto e visualizzare il PDF generato.
                                    </div>}
                                </Card.Body>
                            </Card>
                        </div>
                    </Row>
                </Tab.Container>
            </div>
        </>
    )

}
export default AdminUserTransactionsEdit;